/* src/app/pages/casos/listacasos/listacasos.component.scss */
/*# sourceMappingURL=listacasos.component.css.map */
